import {combineReducers} from 'redux'
import {OPENING_TICKET_PURPOSE_REF_LOADED, OPENING_TICKET_PURPOSE_REF_QUERIED, ACTIVITY_REF_LOADED, ACTIVITY_REF_QUERIED, TICKET_CLAIM_REF_LOADED, CREATE_UPDATE_TAG_ACTION_RESET, CREATE_UPDATE_CATEGORY_ACTION_RESET} from './actions'
import {CREATE_OPENING_TICKET_PURPOSE_ACTION_UPDATED, UPDATE_OPENING_TICKET_PURPOSE_ACTION_UPDATED, CREATE_UPDATE_TAG_ACTION_UPDATED, CREATE_UPDATE_CATEGORY_ACTION_UPDATED, ASSOCIATE_ACTIVITY_WITH_OPENING_TICKET_PURPOSE_ACTION_UPDATED} from './actions'
import {CREATE_OPENING_TICKET_PURPOSE_ACTION_SENT, UPDATE_OPENING_TICKET_PURPOSE_ACTION_SENT, CREATE_UPDATE_TAG_ACTION_SENT, CREATE_UPDATE_CATEGORY_ACTION_SENT, ASSOCIATE_ACTIVITY_WITH_OPENING_TICKET_PURPOSE_ACTION_SENT} from './actions'

function openingTicketPurposeRef(state = null, action) {
    switch (action.type) {
        case OPENING_TICKET_PURPOSE_REF_LOADED:
        case OPENING_TICKET_PURPOSE_REF_QUERIED:
            return action.ref
        default:
            return state
    }
}

function activityRef(state = [], action) {
    switch (action.type) {
        case ACTIVITY_REF_LOADED:
        case ACTIVITY_REF_QUERIED:
            return action.ref
        default:
            return state
    }   
}

function ticketClaimRef(state = null, action) {
    switch (action.type) {
        case TICKET_CLAIM_REF_LOADED:
            return action.ref
        default:
            return state
    }   
}

function createOpeningTicketPurposeAction(state = null, action) {
    switch (action.type) {
        case CREATE_OPENING_TICKET_PURPOSE_ACTION_UPDATED:
            return {...state, ...action.action}
        case CREATE_OPENING_TICKET_PURPOSE_ACTION_SENT:
            return null
        default:
            return state
    }
}

function updateOpeningTicketPurposeAction(state = null, action) {
    switch (action.type) {
        case UPDATE_OPENING_TICKET_PURPOSE_ACTION_UPDATED:
            return {...state, ...action.action}
        case UPDATE_OPENING_TICKET_PURPOSE_ACTION_SENT:
            return null
        default:
            return state
    }
}

function createUpdateTagAction(state = null, action) {
    switch (action.type) {
        case CREATE_UPDATE_TAG_ACTION_UPDATED:
            return {...state, ...action.action}
        case CREATE_UPDATE_TAG_ACTION_RESET:
            return action.action
        case CREATE_UPDATE_TAG_ACTION_SENT:
            return null
        default:
            return state
    }
}

function createUpdateCategoryAction(state = null, action) {
    switch (action.type) {
        case CREATE_UPDATE_CATEGORY_ACTION_UPDATED:
            return {...state, ...action.action}
        case CREATE_UPDATE_CATEGORY_ACTION_RESET:
            return action.action
        case CREATE_UPDATE_CATEGORY_ACTION_SENT:
            return null
        default:
            return state
    }
}

function associateActivityWithOpeningTicketPurposeAction(state = null, action) {
    switch (action.type) {
        case ASSOCIATE_ACTIVITY_WITH_OPENING_TICKET_PURPOSE_ACTION_UPDATED:
            return {...state, ...action.action}
        case ASSOCIATE_ACTIVITY_WITH_OPENING_TICKET_PURPOSE_ACTION_SENT:
            return null
        default:
            return state
    }
}

export default combineReducers({
    openingTicketPurposeRef,
    activityRef,
    ticketClaimRef,
    createOpeningTicketPurposeAction,
    updateOpeningTicketPurposeAction,
    createUpdateTagAction,
    createUpdateCategoryAction,
    associateActivityWithOpeningTicketPurposeAction
})


// WEBPACK FOOTER //
// ./lib/reference/reducers.js